/**
 * https://yandex.ru/dev/jsapi30/doc/ru/ api
 * https://yandex.ru/dev/jsapi30/doc/ru/examples/cases/async-api-load Асинхронная загрузка JS Map API
 * https://yandex.ru/dev/jsapi30/doc/ru/ref/packages/ пакеты
 * https://qna.habr.com/q/1323618 полезное
 *
 *
 * Долгота longitude coord2 - указывает его положение к западу или востоку
 * Широта Latitude coord1 - обозначает расположение места к северу или югу от экватора
 */

import loadMapScript from "./loadMapScript.js";

// карта в "Где купить" со всеми объектами
function contactsListMap() {
    window.contactsListMap = (itemsArr = null, apiKeyYandex = null) => {

        const mapID = document.getElementById('contacts-block-list__map');

        if(!apiKeyYandex){
            console.error('Не введен API-ключ яндекса!');
            return false;
        }

        window.map = null;

        // Flag that indicates whether the JS Map API is currently being loaded
        let isLoading = false;

        // btn map
        const btnMap =  document.querySelector('.contacts-block-list__button');
        btnMap.addEventListener('click', (e) => {
            e.preventDefault();
            btnMap.classList.toggle('contacts-block-list__button_open');
            if(btnMap.classList.contains('contacts-block-list__button_open')){
                btnMap.textContent = 'Свернуть карту';
            } else {
                btnMap.textContent = 'Развернуть карту';
            }
            document.querySelector('.contacts-block-list__map').slideToggle();
        });

        btnMap.addEventListener('click', () => {
            // If the JS Map API is currently loading, then do nothing
            if (isLoading) return;

            // If ymaps3 is not defined, fetch the script and create the map
            if (typeof ymaps3 === 'undefined') {
                fetchScript().then((res) => {
                    if (res === 'error') return;
                    createMap();
                });

                return;
            }

            // If the map is not yet created, create it
            !map && createMap();
        }, {once: true});


        async function createMap() {
            await ymaps3.ready;

            // map
            const {
                YMap,
                YMapDefaultSchemeLayer
            } = ymaps3;

            const map = new YMap(
                mapID,
                {
                    location: {
                        center: (itemsArr.length === 1 ? [itemsArr[0]['coord2'], itemsArr[0]['coord1']] : [37.64, 55.76]), // [37.64, 55.76] координаты Москвы
                        zoom: 16,
                    }
                }
            );

            map.addChild(new YMapDefaultSchemeLayer());
            // /map

            // controls
            if (window.innerWidth > 768) { // только на планшете и десктопе
                const {
                    YMapControls,
                } = ymaps3;

                const {
                    YMapZoomControl,
                    YMapGeolocationControl
                } = await ymaps3.import('@yandex/ymaps3-controls@0.0.1');

                const controls = new YMapControls({position: 'right', orientation: 'vertical'});

                controls.addChild(
                    new YMapZoomControl({
                        easing: 'linear'
                    })
                );

                controls.addChild(new YMapGeolocationControl());
                map.addChild(controls);
            }
            // /controls

            // marker default
            const {
                YMapDefaultFeaturesLayer
            } = ymaps3;

            const {
                YMapDefaultMarker,
            } = await ymaps3.import('@yandex/ymaps3-markers@0.0.1');

            const markersLayer = map.addChild(new YMapDefaultFeaturesLayer({zIndex: 1800}));
            const arrLng = [];
            const arrLat = [];

            itemsArr.forEach((item, key) => {
                let popupContent = '';

                if (item['img_preview'] || item['phone1'] || item['phone2'] || item['phone3'] || item['email'] || item['email2'] || item['emai3']) {
                    popupContent = '<div class="ymap__flex">';
                    if (item['is_img_preview']) {
                        popupContent += `<a href="${item['link']}"><img class="ymap__img img-fluid" src="${item['img_preview']}"></a>`;
                    }
                    if (item['phone1'] || item['phone2'] || item['phone3'] || item['email'] || item['email2'] || item['emai3']) {
                        popupContent += '<div class="ymap__text-container">';
                    }
                    if (item['phone1']) {
                        popupContent += `<a href="tel:${item['phone1_normal']}" class="link nowrap" title="Позвонить">${item['phone1']}</a>`;
                    }
                    if (item['phone2']) {
                        popupContent += `<a href="tel:${item['phone2_normal']}" class="link nowrap" title="Позвонить">${item['phone2']}</a>`;
                    }
                    if (item['phone3']) {
                        popupContent += `<a href="tel:${item['phone3_normal']}" class="link nowrap" title="Позвонить">${item['phone3']}</a>`;
                    }
                    if (item['email']) {
                        popupContent += `<a href="mailto:${item['email']}" class="link" title="Написать письмо">${item['email']}</a>`;
                    }
                    if (item['email2']) {
                        popupContent += `<a href="mailto:${item['email2']}" class="link" title="Написать письмо">${item['email2']}</a>`;
                    }
                    if (item['email3']) {
                        popupContent += `<a href="mailto:${item['email3']}" class="link" title="Написать письмо">${item['email3']}</a>`;
                    }
                    if (item['phone1'] || item['phone2'] || item['phone3'] || item['email'] || item['email2'] || item['emai3']) {
                        popupContent += '</div>';
                    }
                    popupContent += '</div>';
                }

                const defaultMarker = new YMapDefaultMarker({
                    coordinates: [item['coord2'], item['coord1']],
                    title: `<div class="ymap-title">${item['title_h1']}</div>`,
                    subtitle: `<div class="ymap-subtitle">${item['adress_text']}</div>`,
                    color: 'blue',
                    popup: {
                        content: `<div class="ymap">
                                    <a href="${item['link']}" class="ymap__title link">${item['title_h1']}</a>
                                    <div class="ymap__text">${item['adress_text']}</div>
                                    ${popupContent}
                                    <div class="ymap__btns">
                                        <a href="https://yandex.ru/maps/?rtext=~${item['coord1']}%2C${item['coord2']}" class="ymap__btn" target="_blank">                        
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" fill="none"><path fill="#F43" d="M7 0a7 7 0 0 0-4.95 11.95c1.27 1.27 4.25 3.1 4.42 5.03.03.28.24.52.53.52.29 0 .5-.24.53-.52.17-1.93 3.15-3.76 4.42-5.03A7 7 0 0 0 7 0z"/><path fill="#fff" d="M7 9.45a2.45 2.45 0 1 0 0-4.9 2.45 2.45 0 0 0 0 4.9z"/></svg>
                                            Как добраться
                                        </a>
                                        <a href="https://3.redirect.appmetrica.yandex.com/route?end-lat=${item['coord1']}&end-lon=${item['coord2']}&appmetrica_tracking_id=1178268795219780156" class="ymap__btn" target="_blank">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"><path fill="#fc0" d="M4.5 1A3.5 3.5 0 0 0 1 4.5V9h16V4.5A3.5 3.5 0 0 0 13.5 1h-9z"/><path fill="#e6e6e6" d="M1 9v4.5A3.5 3.5 0 0 0 4.5 17H9V9H1z"/><path fill="#000" d="M9 9v8h4.5a3.5 3.5 0 0 0 3.5-3.5V9H9z"/></svg>
                                            Доехать на такси
                                        </a>
                                    </div>                                               
                                </div>`,
                        hidesMarker: true,
                        position: "right"
                    }
                });

                markersLayer.addChild(defaultMarker);

                arrLng.push(item['coord2']);
                arrLat.push(item['coord1']);
            });
            // /marker default

            if(itemsArr && itemsArr.length > 1){
                const min = (values) => values.reduce((x, y) => Math.min(x, y));
                const max = (values) => values.reduce((x, y) => Math.max(x, y));

                const minLng = min(arrLng);
                const maxLng = max(arrLng);
                const minLat = min(arrLat);
                const maxLat = max(arrLat);

                map.setLocation({
                    bounds: [
                        [minLng, maxLat],
                        [maxLng, minLat]
                    ],
                });
            }
        }

        // Function to toggle the visibility of the loading spinner
        function toggleLoader() {
            mapID.classList.toggle('loader-hide', !isLoading);
        }

        async function fetchScript() {
            try {
                // Set loading flag to true and show the loading spinner
                isLoading = true;
                toggleLoader();

                // Load the JS Map API script
                await loadMapScript(`https://api-maps.yandex.ru/v3/?apikey=${apiKeyYandex}&lang=ru_RU`);
            } catch (error) {
                // Log any errors that occur during script loading
                console.error(error);
                return 'error';
            } finally {
                // Set loading flag to false and hide the loading spinner
                isLoading = false;
                toggleLoader();
            }
        }
    }
}

// Выбор города
function selectCity(){
    const selectCity = document.querySelector(".form-control_select-city");
    if(selectCity){
        selectCity.addEventListener('change', (e) => {

            if(e.target.value > 0){
                document.querySelector(".contacts-block-list__form-city").submit();
            }
        });
    }
}

export default contactsListMap;
export {selectCity};